import { AddEdit } from '../../../../interfaces/payment.interface';
import { Edit as EditInterface } from '../../../../interfaces/invoice.interface';
import { Validation } from '../../../../interfaces/common';
import { APP_ERROR_MESSAGES, VALIDATION_FIELD_MAPPING, Regex, PAYMENT_ACCOUNTS } from '../../../../utils/appConstant';

export const validateAddEditPaymentForm = (formData: AddEdit, allAccounts: any[], fieldToValidate?: string) => {
  const validations: Validation = { validate: true, fields: [] };

  if (!fieldToValidate || fieldToValidate === VALIDATION_FIELD_MAPPING.date) {
    if (!formData.date) {
      validations.validate = false;
      validations.fields.push({
        field: VALIDATION_FIELD_MAPPING.date,
        message: APP_ERROR_MESSAGES.invoices.editPreviewPayment.blankDate
      });
    }
  }

  const isCarryForward = formData.type === 'carry_forward';

  if (!isCarryForward && (!fieldToValidate || fieldToValidate === VALIDATION_FIELD_MAPPING.account)) {
    if (!formData.account) {
      validations.validate = false;
      validations.fields.push({
        field: VALIDATION_FIELD_MAPPING.account,
        message: APP_ERROR_MESSAGES.invoices.editPreviewPayment.blankAccount
      });
    }
  }

  if (!fieldToValidate || fieldToValidate === VALIDATION_FIELD_MAPPING.account || fieldToValidate === VALIDATION_FIELD_MAPPING.notes) {
    const selectedAccount = formData.account;
    const otherId = allAccounts.find(item => item.code === PAYMENT_ACCOUNTS.OTHER)?.id;

    if (!isCarryForward && (selectedAccount === otherId) && !formData.notes?.trim()) {
      validations.validate = false;
      validations.fields.push({
        field: VALIDATION_FIELD_MAPPING.notes,
        message: APP_ERROR_MESSAGES.invoices.editPreviewPayment.blankNotes
      });
    }

    if (isCarryForward && !formData.notes?.trim()) {
      validations.validate = false;
      validations.fields.push({
        field: VALIDATION_FIELD_MAPPING.notes,
        message: APP_ERROR_MESSAGES.invoices.editPreviewPayment.blankNotes
      });
    }
  }

  if (!isCarryForward && (!fieldToValidate || fieldToValidate === VALIDATION_FIELD_MAPPING.method)) {
    if (!formData.method) {
      validations.validate = false;
      validations.fields.push({
        field: VALIDATION_FIELD_MAPPING.method,
        message: APP_ERROR_MESSAGES.invoices.editPreviewPayment.blankMethod
      });
    }
  }

  if (!fieldToValidate || fieldToValidate === VALIDATION_FIELD_MAPPING.amount) {
    if (!formData.amount) {
      validations.validate = false;
      validations.fields.push({
        field: VALIDATION_FIELD_MAPPING.amount,
        message: APP_ERROR_MESSAGES.invoices.editPreviewPayment.blankAmount
      });
    } else if (formData.amount && !Regex.floatValues.test(formData.amount.trim())) {
      validations.validate = false;
      validations.fields.push({
        field: VALIDATION_FIELD_MAPPING.amount,
        message: APP_ERROR_MESSAGES.invoices.editPreviewPayment.invalidAmount,
      });
    } else {
      const numValue = parseFloat(formData.amount);
      if (numValue < 0) {
        validations.validate = false;
        validations.fields.push({
          field: VALIDATION_FIELD_MAPPING.amount,
          message: APP_ERROR_MESSAGES.invoices.editPreviewPayment.invalidAmount,
        });
      }
    }
  }

  return validations;
};

export const validateEditDetailsTabForm = (formData: EditInterface, fieldToValidate?: string): Validation => {
  const validations: Validation = { validate: true, fields: [] };

  if (!fieldToValidate || fieldToValidate === VALIDATION_FIELD_MAPPING.reviewed || fieldToValidate === VALIDATION_FIELD_MAPPING.reviewedBy) {
    const reviewed = !formData.reviewed;
    if (reviewed && !formData.reviewedBy) {
      validations.validate = false;
      validations.fields.push({
        field: VALIDATION_FIELD_MAPPING.reviewedBy,
        message: APP_ERROR_MESSAGES.invoices.editPreviewPayment.blankReviewedBy
      });
    }
  }

  if (!fieldToValidate || fieldToValidate === VALIDATION_FIELD_MAPPING.reviewed || fieldToValidate === VALIDATION_FIELD_MAPPING.notes) {
    if (!formData.reviewed && !formData.notes?.trim()) {
      validations.validate = false;
      validations.fields.push({
        field: VALIDATION_FIELD_MAPPING.notes,
        message: APP_ERROR_MESSAGES.invoices.editPreviewPayment.blankNotesDetails
      });
    }
  }

  if (!fieldToValidate || fieldToValidate === VALIDATION_FIELD_MAPPING.includeNotes || fieldToValidate === VALIDATION_FIELD_MAPPING.notes) {
    if (formData.includeNotes && !formData.notes?.trim()) {
      validations.validate = false;
      validations.fields.push({
        field: VALIDATION_FIELD_MAPPING.notes,
        message: APP_ERROR_MESSAGES.invoices.editPreviewPayment.blankNotesDetails
      });
    }
  }

  return validations;
};
